export default __webpack_public_path__ + "static/media/croped_img3.e3c3e70e.jpeg";